<template>
  <div class="fanshui-page">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()" />
      </div>
      <span class="head_text">{{ $t('返水中心') }}</span>
      <span class="right_menu"></span>
    </div>

    <div class="content">
      <div style="padding-bottom: 10px; display: flex; align-items: center; justify-content: space-between">
        <span style="font-size: 0.32rem"> {{ $t('返水记录') }} </span>
        <van-button style="width: 3rem; height: 0.68rem; min-width: 80px;border-radius: .27rem;background: #321aac;border-color: #321aac;" type="info" @click="lingqu"><span style="color: #fff; font-size: 0.32rem">{{ $t('点击领取') }}</span></van-button>
      </div>
      <div class="card-list">
        <div class="card-item">
          <div class="label">{{ $t('累计领取') }}</div>
          <div class="value">{{ jisuan }}</div>
          <img src="/static/image/new/mine/fanshui-icon1.png" alt="" class="icon">
        </div>
        <div class="card-item">
          <div class="label">{{ $t('待领取') }}</div>
          <div class="value">{{ nojisuan }}</div>
          <img src="/static/image/new/mine/fanshui-icon2.png" alt="" class="icon">
        </div>
      </div>
      <!-- 筛选条件 -->
      <div class="saibox">
        <div class="sai" @click="showPopup(1)">{{ name }}</div>
        <div class="sai" @click="showPopup(2)">{{ dateName[date] }}</div>
      </div>
      <van-list style="margin-top: 10px; padding-bottom: 120px" :finished-text="$t('没有更多了')" offset="300" v-model="loading" :finished="list.length == pageData.total" @load="getData" v-if="list.length > 0">
        <van-cell v-for="(item, index) in list" :key="index">
          <div style="color: #888 !important">
            <div style="display: flex; justify-content: space-between; font-size: 0.3rem">
              {{ item.gamename }} <span style="font-size: 0.3rem">{{ $t('返水金额') }} :{{ item.money }}</span>
            </div>
            <div style="font-size: 0.3rem">{{ $t('返水时间') }}:{{ item.created_at }}</div>
            <div style="font-size: 0.3rem">{{ $t('领取时间') }}：{{ item.state == 0 ? $t('暂未领取') : item.updated_at }}</div>
          </div>
        </van-cell>
      </van-list>
      <div v-else style="margin-top: 60px; text-align: center">
        <img src="/static/image/new/mine/mescroll-empty.png" style="width: 3.68rem;" alt="" />
        <div style="font-size: .37rem;color: #999;margin-top: .43rem">{{ $t('空空如也') }}</div>
      </div>
    </div>
    <!-- 弹出层 -->
    <van-popup v-model="popup" position="bottom" :style="{ height: 'calc(100% - 3.9rem - 46px)' }">
      <div class="lisg" v-if="showXuan == 1">
        <div class="bs" v-for="(item, index) in dogameLis" :key="index" @click="changDogame(item.name, item.platname)">
          <div :class="api_type == item.platname ? 'lisga act' : 'lisga'">{{ item.name }}</div>
        </div>
      </div>
      <div class="lisg" v-if="showXuan == 2">
        <div class="bs" @click="changtype('date', 1)">
          <div :class="date == 1 ? 'lisga act' : 'lisga'">{{ $t('今日') }}</div>
        </div>
        <div class="bs" @click="changtype('date', 2)">
          <div :class="date == 2 ? 'lisga act' : 'lisga'">{{ $t('近7日') }}</div>
        </div>
        <div class="bs" @click="changtype('date', 3)">
          <div :class="date == 3 ? 'lisga act' : 'lisga'">{{ $t('近15日') }}</div>
        </div>
        <div class="bs" @click="changtype('date', 4)">
          <div :class="date == 4 ? 'lisga act' : 'lisga'">{{ $t('近30日') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'fanshui',
  data() {
    return {
      date: 4,
      list: [],
      pageData: {},
      page: 1,
      dogameLis: [],
      api_type: '',
      loading: false,
      name: this.$t('全平台'),
      show: false,
      jisuan: 0,
      nojisuan: 0,
      dateName: ['', this.$t('今日'), this.$t('近7日'), this.$t('近15日'), this.$t('近30日')],
      popup: false,
      showXuan: 1, //1平台选择 2 日期选择
    };
  },
  created() {
    let that = this;
    that.getdogame();
    that.getData();
  },
  methods: {
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    changDogame(name, type) {
      let that = this;
      that.name = name;
      that.api_type = type;
      that.popup = false;
      that.page = 1;
      that.getData();
    },
    changtype(name, val) {
      let that = this;
      that[name] = val;
      that.popup = false;
      that.page = 1;
      that.getData();
    },
    showPopup(val) {
      this.popup = true;
      this.showXuan = val;
    },
    lingqu() {
      let that = this;
      let fanshui = that.nojisuan;
      if (fanshui <= 0) {
        that.$parent.showTost(0, this.$t('暂无领取额度') + '！');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/dofanshui', {})
        .then(res => {
          console.log(res);
          that.$parent.getUserInfo();
          that.showTost(1, res.message);
          that.getfanshui();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },

    openOrclose() {
      this.show = !this.show;
    },
    changtab() {
      let that = this;
      that.page = 1;
      that.list = [];
      that.pageData = {};
      that.getData();
    },
    getdogame() {
      let that = this;

      that.$apiFun.post('/api/balancelist', {}).then(async (res) => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          // that.dogameLis = res.data;
          const list = res.data
          const text = await translateText(list)
          list[0].name = text[0]
          that.dogameLis = [
            list[0]
          ];
        }
      });
    },
    changeDate() {
      let that = this;
      that.page = 1;
      that.getData();
    },

    // 获取交易记录
    getData() {
      let that = this;
      let page = that.page;
      if (page > that.pageData.last_page) {
        that.loading = false;

        return;
      }
      that.$parent.showLoading();
      let info = {
        date: that.date,
        page: that.page,
        api_type: that.api_type,
        type: '',
      };
      that.$apiFun
        .post('/api/getfanshui', info)
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.pageData = res.data.list;
            that.jisuan = res.data.jisuan;
            that.nojisuan = res.data.nojisuan;
            if (that.page == 1) {
              that.list = res.data.list.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              res.data.list.data.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
            that.page = page + 1;
          }
          that.loading = false;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
          that.loading = false;
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
// @import '../../static/css/chunk-10680dc4.7fc8cdde.css';
.fanshui-page {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding: 0 .4rem;
    .card-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-item {
        width: 4.45rem;
        height: 1.87rem;
        border-radius: .27rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 .28rem;
        position: relative;
        background: linear-gradient(to right, #321aac, #5417a3);
        padding-right: 1.3rem;
        &:last-child {
          background: linear-gradient(to right, #833801, #951901);
        }
        .label {
          font-size: 0.37rem;
          font-weight: bold;
        }
        .value {
          font-size: 0.37rem;
          margin-top: .2rem;
        }
        .icon {
          position: absolute;
          top: 50%;
          right: .28rem;
          transform: translateY(-50%);
          width: 1.07rem;
          height: 1.07rem;

        }
      }
    }
    .saibox {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: .85rem;
      box-sizing: border-box;
      margin-top: .27rem;
      .sai {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 4.45rem;
        background: rgba(255, 255, 255, 0.10);
        border: 0.03rem solid rgba(255, 255, 255, 0.10);
        border-radius: 1.14rem;
        font-size: 0.32rem;
      }
    }
  }
  .lisg {
    box-sizing: border-box;
    padding: 10px 8px;
    display: flex;
    flex-wrap: wrap;
    .bs {
      width: 25%;
      height: 1.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .lisga {
        width: calc(100% - 8px);
        height: 0.9rem;
        border: 0.02rem solid #cbced8;
        border-radius: 0.08rem;
        color: #a5a9b3;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.2rem;
        text-align: center;
      }
      .lisga.act {
        background: #ede9e7;
        color: #fff;
        border: none;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/fanshui.vue